import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Divider,
  Input,
  Button,
  Tooltip,
  Select,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  defaultSort,
  getTablePagesize,
  selectFilterFunction,
  setTablePageSize,
} from "../../../Constants/Utilities";
import { StatusSwitch } from "../../Common/StatusSwitch";
import {
  ConfigActions,
  EntityStatus,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../../Constants/Constants";
import { BreadCrumbs } from "../../Common/BreadCrumbs";

class ListServiceProviderConfig extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListServiceProviderConfig props", props);
    this.state = {
      providerConfigData: props.providerConfigData,
    };
  }

  componentDidUpdate(prevProps) {
    const { providerData, providerConfigData } = this.props;
    if (
      prevProps.providerData !== providerData ||
      prevProps.providerConfigData !== providerConfigData
    ) {
      this.setState({ providerData, providerConfigData });
    }
  }

  getColumns = () => [
    {
      title: "Configuration Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(ConfigActions.view, record)}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Config">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(ConfigActions.view, record)}
            />
          </Tooltip>
          <Tooltip title="Edit Config">
            <EditOutlined
              onClick={this.props.onActionClick(ConfigActions.edit, record)}
            />
          </Tooltip>
          {record.status === EntityStatus.INACTIVE && (
            <Tooltip title="Delete Config">
              <Popconfirm
                okText="Yes"
                cancelText="No"
                title="Are you sure want to Delete Config?"
                onConfirm={() => this.props.deleteServiceProviderConfig(record)}
              >
                <DeleteOutlined />
              </Popconfirm>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { providerConfigData } = this.props;
    if (!!text) {
      const filteredData = providerConfigData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ providerConfigData: filteredData });
      return;
    }
    this.setState({ providerConfigData });
  };

  render() {
    const { providerConfigData } = this.state;
    const {
      providerData,
      providerDataLoading,
      onActionClick,
      selectedProvider,
      onProviderSelect,
      deleteConfigLoading,
      providerConfigDataLoading,
      parentBread,
    } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <div className="entity-selection-container">
          <span className="entity-label">Service Provider:</span>
          <Select
            showSearch
            allowClear
            value={selectedProvider}
            loading={providerDataLoading}
            disabled={providerDataLoading}
            onChange={onProviderSelect}
            filterOption={selectFilterFunction}
            style={{ minWidth: "250px", maxWidth: "300px" }}
            placeholder={
              providerDataLoading
                ? "Loading Service Providers..."
                : "Select Service Provider"
            }
          >
            {providerData?.map((item) => (
              <Select.Option key={item.providerId} title={item.providerName}>
                {item.providerName}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Config Name"
              onChange={this.onSerchTextChange}
              disabled={!selectedProvider}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ConfigActions.add, null)}
            >
              Add Configuration
            </Button>
          </div>
        </div>
        {!selectedProvider ? (
          <div className="no-entity-warning">
            <div className="warning-label">
              Select any Service Provider to view configurations
            </div>
          </div>
        ) : (
          <Table
            bordered
            size="small"
            columns={this.getColumns()}
            className="entity-table"
            loading={
              providerConfigDataLoading ||
              (deleteConfigLoading && {
                tip: "Fetching Configurations...",
              })
            }
            dataSource={providerConfigData}
            pagination={{
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              defaultPageSize: getTablePagesize(
                TablePages.listServiceProviderConfig
              ),
              pageSizeOptions: TablePageSizes,
              onChange: (_, pageSize) =>
                setTablePageSize(
                  TablePages.listServiceProviderConfig,
                  pageSize
                ),
            }}
          />
        )}
      </div>
    );
  }
}

ListServiceProviderConfig.propTypes = {
  providerData: PropTypes.array,
  providerDataLoading: PropTypes.bool,
  selectedProvider: PropTypes.string,
  providerConfigData: PropTypes.array,
  providerConfigDataLoading: PropTypes.bool,
  deleteConfigLoading: PropTypes.bool,
  onProviderSelect: PropTypes.func,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default ListServiceProviderConfig;
